import React from 'react';
import { Collapse } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

interface GuardrailsInfoSectionProps {
  assistantName: string;
}

const GuardrailsInfoSection: React.FC<GuardrailsInfoSectionProps> = ({ assistantName }) => {
  const name = assistantName || 'Donna';

  const items = [
    { title: 'Personnalité et ton', text: 'Annonce IA, phrases courtes, une question à la fois, vouvoiement.' },
    {
      title: 'Garde-fous',
      text: 'Aucun prix, aucune estimation, aucun délai de rappel promis, aucun transfert d’appel. Vos consignes passent après ces règles.',
    },
    { title: 'Urgence', text: `${name} signale les appels où une affaire se joue.` },
    {
      title: 'Compte rendu',
      text: 'Motif, résumé, ce qu’il reste à faire : dans le fil d’appels et la fiche contact.',
    },
  ];

  return (
    <Collapse
      ghost
      expandIconPosition="end"
      className="receptionist-ai-detail-page__section receptionist-ai-detail-page__managed"
      items={[
        {
          key: 'managed',
          label: <h3 className="receptionist-ai-detail-page__section-title">Ce que Leedflow gère à votre place</h3>,
          extra: (
            <span className="receptionist-ai-detail-page__managed-summary">
              Ton · Garde-fous · Urgence · Compte rendu
            </span>
          ),
          children: (
            <div className="receptionist-ai-detail-page__managed-grid">
              {items.map((item) => (
                <div key={item.title}>
                  <span className="receptionist-ai-detail-page__managed-item-title">
                    <CheckOutlined />
                    {item.title}
                  </span>
                  <p className="receptionist-ai-detail-page__managed-item-text">{item.text}</p>
                </div>
              ))}
            </div>
          ),
        },
      ]}
    />
  );
};

export default GuardrailsInfoSection;
